import React, { useEffect } from "react";
import {
  Box,
  Container,
  Skeleton,
  Alert,
  Pagination,
  Typography,
} from "@mui/material";

import ProductCard from "./ProductCard";

export default function LandingUI({
  products = [],
  loading,
  error,
  count = 1,
  page = 1,
  onPageChange,
}) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  return (
    <Box
      dir="rtl"
      sx={{
        bgcolor: "#f7f7f7",
        py: { xs: 2, sm: 3 },
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="xl" disableGutters>
        <Box sx={{ px: { xs: 0.5, sm: 2 } }}>
          <Typography
            component="h1"
            variant="h6"
            fontWeight={800}
            sx={{
              mb: 2,
              fontSize: { xs: "1.05rem", sm: "1.25rem" },
            }}
          >
            همه محصولات
          </Typography>

          {loading ? (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: { xs: 0.5, sm: 1 },
              }}
            >
              {Array.from({ length: 8 }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  height={280}
                  sx={{ borderRadius: 2 }}
                />
              ))}
            </Box>
          ) : error ? (
            <Alert severity="error" sx={{ borderRadius: 3 }}>
              {error}
            </Alert>
          ) : products.length > 0 ? (
            <>
              {/* Two-column product grid */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "repeat(2, minmax(0, 1fr))",
                    sm: "repeat(3, minmax(0, 1fr))",
                    md: "repeat(3, minmax(0, 1fr))",
                    lg: "repeat(4, minmax(0, 1fr))",
                  },
                  gap: { xs: 0.75, sm: 1.25, md: 1.5 },
                  alignItems: "stretch",
                }}
              >
                {products.map((product, index) => (
                  <Box
                    key={product.id || product.slug || index}
                    sx={{ minWidth: 0 }}
                  >
                    <ProductCard product={product} />
                  </Box>
                ))}
              </Box>

              {/* Pagination */}
              {count > 1 && (
                <Box
                  sx={{
                    mt: 3,
                    display: "flex",
                    justifyContent: "center",
                    pb: 2,
                  }}
                >
                  <Pagination
                    count={count}
                    page={page}
                    onChange={onPageChange}
                    color="primary"
                    shape="rounded"
                    size="medium"
                    siblingCount={0}
                    boundaryCount={1}
                    sx={{
                      direction: "ltr",
                      "& .MuiPaginationItem-root": {
                        fontWeight: 700,
                      },
                    }}
                  />
                </Box>
              )}
            </>
          ) : (
            <Alert severity="info" sx={{ borderRadius: 3 }}>
              هیچ محصولی یافت نشد.
            </Alert>
          )}
        </Box>
      </Container>
    </Box>
  );
}
